import { PropsValue, StylesConfig } from 'react-select';

import { Option } from '../../../../shared/types';

import colors from '../../../../../chakra/foundations/colors';

export const getCustomStyles = (width?: number): StylesConfig<PropsValue<Option>, true> => {
  const minWidth = 240;
  const fixedMinWidth = width && width >= minWidth ? width : minWidth;
  const fixedMinWidthPx = `${fixedMinWidth}px`;
  const maxValueWidth = fixedMinWidth / 2 - 10;
  const maxValueWidthPx = `${maxValueWidth}px`;

  const customStyles: StylesConfig<PropsValue<Option>, true> = {
    container: () => ({
      width: fixedMinWidthPx,
      minWidth: fixedMinWidthPx,
    }),
    control: () => ({
      backgroundColor: colors.white,
    }),
    option: (_provided, { isFocused, isSelected }) => ({
      color: 'black',
      backgroundColor: isSelected
        ? colors.babyBlueEyes
        : isFocused
        ? colors.azureishWhite
        : colors.white,
    }),
    multiValue: () => ({
      maxWidth: maxValueWidthPx,
      backgroundColor: colors.azureishWhite,
      margin: 0,
      padding: 0,
    }),
  };

  return customStyles;
};
